
import MessageMinus from "../../../assets/duotone/MessageMinus.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MessageMinusIcon({ className, dataTestid = "MessageMinusIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <MessageMinus data-testid={dataTestid} className={classes} {...rest} />
  );
}
